import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExoTable from '../exo/ExoTable';
import MoneyLabel from '../label/MoneyLabel';
import DateLabel from '../label/DateLabel';
import useFetch from '../../api/useFetch';

/**
 * Picker for travel expense reimbursements that still have an open amount, used
 * when assigning a bank transaction to the payout document.
 */
export const SelectTravelExpenseReimbursement = ({ onSelect }) => {
  const { t } = useTranslation();

  const { apiData } = useFetch('travel-expense-reimbursements/open');

  const Columns = [
    {
      header: t('Employee'),
      key: 'user',
      thAlign: 'left',
      tdAlign: 'left',
      cell: ({ row }) => (
        <Typography>
          {row.user ? `${row.user.firstName} ${row.user.lastName}` : ''}
        </Typography>
      ),
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Period'),
      key: 'startDate',
      thAlign: 'right',
      tdAlign: 'right',
      sortable: true,
      width: '220px',
      hiddenMobile: true,
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">
          <DateLabel date={row.startDate} /> - <DateLabel date={row.endDate} />
        </Box>
      ),
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Brutto'),
      key: 'amount',
      thAlign: 'right',
      tdAlign: 'right',
      sortable: true,
      width: '120px',
      cell: ({ row }) => (
        <Box className="monospace">
          <MoneyLabel money={row.amount} />
        </Box>
      ),
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Open'),
      key: 'openAmount',
      thAlign: 'right',
      tdAlign: 'right',
      width: '120px',
      cell: ({ row }) => (
        <Typography className="monospace">
          <MoneyLabel money={row.openAmount} />
        </Typography>
      ),
      onClick: (row) => onSelect(row),
    },
  ];

  return (
    <ExoTable
      data={apiData}
      columns={Columns}
      isLoading={!apiData}
      className="h-full w-full"
    />
  );
};
